import React from 'react';
import { GridTableRowProps } from 'shared/components/Grid/GridTableRow';
import { Contribution, ContributionInvestment } from './api';
import { numberWithCommas } from 'shared/utils/numberUtils';
import { formattedDate } from 'shared/utils/date';

export const getTotalContributionAmount = (row: ContributionInvestment) => {
  const totalContribution =
    (row.cashAmount || 0) +
    (row.goodsAmount || 0) +
    (row.servicesAmount || 0) +
    (row.volunteerismAmount || 0);
  let totalAllocatedAmount = 0;
  for (const a of row.allocations) {
    totalAllocatedAmount += a.amount;
  }
  return { totalAllocatedAmount, totalContribution };
};

const getAllServices = (row: ContributionInvestment) => {
  const result: string[] = [];
  for (const a of row.allocations) {
    a.report.service && result.push(a.report.service);
  }
  return result;
};

const parseDueDate = (date: string) => {
  const d = date.split('/');
  return new Date(Number(d[2]), Number(d[1]) - 1, Number(d[1]));
};

const getNextTaskDueDate = (row: ContributionInvestment) => {
  let nextDueDate: Date | null = null;
  for (const a of row.allocations) {
    for (const t of a.tasks) {
      if (t.due) {
        const dueDate = parseDueDate(t.due);
        if (!nextDueDate || dueDate < nextDueDate) {
          nextDueDate = dueDate;
        }
      }
    }
  }
  return nextDueDate ? formattedDate(nextDueDate) : '-';
};

export const contributionHeaders = (
  data: Contribution,
  onContributionClick: (
    d: Contribution,
    r: ContributionInvestment,
    i: number,
  ) => unknown,
): GridTableRowProps<ContributionInvestment>['headers'] => {
  return [
    {
      text: 'Organization',
      Render: ({ row }) => (
        <td>{row.invitations[0]?.organization || 'Not set'}</td>
      ),
    },
    {
      text: 'Program',
      Render: ({ row }) => <td>{row.programNameByDonor || '-'}</td>,
    },
    {
      text: 'Year',
      Render: () => <td>{data.year}</td>,
    },
    {
      text: 'Stage',
      Render: ({ row }) => <td>{row.allocations[0]?.report.stage || '-'}</td>,
    },
    {
      text: 'Status',
      Render: ({ row }) => <td>{row.allocations[0]?.report.status || '-'}</td>,
    },
    // {
    //   text: 'Next Task Due',
    //   Render: ({ row }) => <td>{getNextTaskDueDate(row)}</td>,
    // },
    {
      text: 'Contribution',
      Render: ({ row, index }) => {
        const total = getTotalContributionAmount(row);
        return (
          <td
            onClick={() => onContributionClick(data, row, index)}
            className="contribution-link"
          >
            ${numberWithCommas(total.totalContribution)}
          </td>
        );
      },
    },
    // {
    //   text: 'Service',
    //   Render: ({ row }) => <td>{getAllServices(row)[0] || '-'}</td>,
    // },
  ];
};
